module.exports = __webpack_public_path__ + "static/media/wifi-mapper-scanner.74b42f43.jpg";